import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

import theme from './theme';

const colorsMain = Object.keys(theme.colors).filter((name) => !name.includes('_')); // exclude colors with tints

const GlobalStyles = createGlobalStyle`
  ${normalize}

  :root {
    --typography-fontPrimary: 'Inter', sans-serif;
    --typography-fontMono: 'Roboto Mono', monospace;
    ${colorsMain.map((colorName) => `--colors-${colorName}: ${theme.colors[colorName]};`)}
  }

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -ms-interpolation-mode: nearest-neighbor;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    font-family: var(--typography-fontPrimary);
    color: var(--colors-darkBlue);
    ${theme.typography.body}
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
  }
`;

export default GlobalStyles;
